//#region react import
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region component import
import GstaInputWithValidation from "../../Components/GstaInputWithValidation/GstaInputWithValidation.component";
import GstaLoaderPage from "../../Components/GstaLoaderPage/GstaLoaderPage.component";
//#endregion

//#region store import
import { setErrorNotification, setSuccessNotification } from "../../ReduxStore/notificationSlice";
import { loadTranslations, setLanguage } from "../../ReduxStore/translationSlice";
//#endregion

//#region functions import
import { getMachineTranslation } from "../../Helper/GetMachineSource";
import { getTranslations, loadGstaDictionnary, loadTranslationFile } from "../../Helper/TranslationController";
import { createDocumentationObject } from "../../Helper/HandleDocumentation";
import { reset } from "../../ReduxStore/gstaTableSlice";
//#endregion

//#region services import
import { getAvailableLanguage, setUserSettings } from "../../Services/SettingsService";
import { getJsonContent } from "../../Services/PatchNotesService";
//#endregion

//#region constants import
import { INPUT_TYPE } from "../../Components/GstaInput/GstaInput.constants";
import { GSTA_LOADER_STYLES } from "../../Components/GstaLoaderPage/GstaLoaderPage.constants";
import { LANGUAGE } from "../../Constants/SettingsConstants";
import { DOCUMENTATION_JSON_FILE } from "../../Constants/Documentation";
//#endregion

//#region styles import
import "./ProfileAccountLayout.style.scss";
//#endregion

const ProfileAccountLayout = () => {
  //#region useSelector
  const translations = useSelector((state) => state.translationSlice.translations);
  const language = useSelector((state) => state.translationSlice.language);
  const connexionSlice = useSelector((state) => state.connexionSlice);
  const traductionDictionaries = useSelector((state) => state.translationSlice.translationsDictionariesToLoad);
  const machines = useSelector((state) => state.machineSlice.machines);
//#endregion

  //#region useState
  const [loading, setLoading] = useState(false);
  const [availableLaguages, setAvailableLanguages] = useState([]);
  const [languageValue, setLanguageValue] = useState();
  //#endregion

  //#region constants
  const centerId = connexionSlice.trainer?.activeCenter.id;
  const userId = connexionSlice.trainer?.id;
  //#endregion

  //#region other use 
  const dispatch = useDispatch();
  //#endregion

  //#region functions
  const handleValidate = async (newLanguage) => {
    const languageToSend = newLanguage?.value ?? newLanguage;
    try {
      if (languageToSend !== language) {
        setLoading(true);
        const newLanguageFromApi = await setUserSettings(newLanguage, centerId, userId, LANGUAGE);
        dispatch(setLanguage(newLanguageFromApi.dataModified));
        const promises = traductionDictionaries.map(async (dictionary) => {
          loadTranslationFile(
            getMachineTranslation(dictionary["acronym"], newLanguageFromApi.dataModified, traductionDictionaries)
          ).then((dictionaryValues) =>
            dispatch(
              loadTranslations({
                translationsToAdd: dictionaryValues,
                language: newLanguageFromApi.dataModified,
              })
            )
          );
        });
        loadGstaDictionnary(newLanguageFromApi.dataModified).then((dictionaryValues) => {
          dispatch(
            loadTranslations({
              translationsToAdd: dictionaryValues,
              language: newLanguageFromApi.dataModified,
            })
          );
          dispatch(setSuccessNotification(getTranslations("notification_language", dictionaryValues)));
          setLoading(false);
        });
        const documentationJson = await getJsonContent(DOCUMENTATION_JSON_FILE);
        await createDocumentationObject(documentationJson, languageToSend, machines, dispatch);
        await Promise.all(promises);
        dispatch(reset());
      }
    } catch (e) {
      dispatch(setErrorNotification(e));
    }
  };
  //#endregion

  //#region useEffect
  useEffect(() => {
    const getLanguageAvailable = async () => {
      setLoading(true);
      let availableLaguages = await getAvailableLanguage();
      availableLaguages = availableLaguages.map((language) => ({
        value: language.value,
        label: getTranslations(language.labelKey, translations),
      }));
      setAvailableLanguages(availableLaguages);
      setLoading(false);
    };
    getLanguageAvailable();
    return () => {
      return;
    };
  }, [translations]);

  useEffect(() => {
    setLanguageValue(availableLaguages.find((languageAvailable) => language === languageAvailable.value));
  }, [language, availableLaguages]);
  //#endregion

  return (
    <div className="profil-account-layout">
      <GstaInputWithValidation
        type={INPUT_TYPE.SELECT}
        label={getTranslations("profil_language", translations)}
        mandatory={true}
        options={availableLaguages}
        setValue={handleValidate}
        value={languageValue}
      />
      {loading && <GstaLoaderPage appearanceClass={GSTA_LOADER_STYLES.OPAQUE} />}
    </div>
  );
};

export default ProfileAccountLayout;
